import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  isShowGlobalLoading = signal(false);

  #allowUrl = ['/order', '/account'];

  constructor() { }

  validateEndPoint(url: string) {
    if (!this.isValidUrl(url))
      return;

    this.isShowGlobalLoading.set(true);
  }

  isValidUrl(url: string) {
    return this.#allowUrl.some(x => url.includes(x));
  }

  close() {
    this.isShowGlobalLoading.set(false);
  }

  open() {
    this.isShowGlobalLoading.set(true);
  }
}
